/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef, useState, useEffect } from 'react'
import { useFrame, useThree } from 'react-three-fiber'
import { useGLTF } from '@react-three/drei/useGLTF'
import { useMatcapTexture, useTexture } from '@react-three/drei'
import { useAnimations } from '@react-three/drei/useAnimations'
export default function Model({ slide, type }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF(process.env.PUBLIC_URL +'/Model.glb')
  const { actions } = useAnimations(animations, group)
  const { viewport } = useThree()
  // const bumpMap = useTexture('https://www.filterforge.com/filters/6103-normal.jpg')
  // console.log(bumpMap)
  // const matcap = useTexture('/matcap.png')
  const [matcap] = useMatcapTexture('2A2A2A_B3B3B3_6D6D6D_848C8C')
  useEffect(() => {
    actions.action12.timeScale = 1.5
    actions.action12.clampWhenFinished = true
    actions.action12.loop = THREE.LoopOnce
    actions.action23.timeScale = 1.5
    actions.action23.clampWhenFinished = true
    actions.action23.loop = THREE.LoopOnce
    actions.action34.timeScale = 1.5
    actions.action34.clampWhenFinished = true
    actions.action34.loop = THREE.LoopOnce
    actions.action45.timeScale = 1.5
    actions.action45.clampWhenFinished = true
    actions.action45.loop = THREE.LoopOnce
    actions.action21.timeScale = 1.5
    actions.action21.clampWhenFinished = true
    actions.action21.loop = THREE.LoopOnce
    actions.action32.timeScale = 1.5
    actions.action32.clampWhenFinished = true
    actions.action32.loop = THREE.LoopOnce
    actions.action43.timeScale = 1.5
    actions.action43.clampWhenFinished = true
    actions.action43.loop = THREE.LoopOnce
    actions.action54.timeScale = 1.5
    actions.action54.clampWhenFinished = true
    actions.action54.loop = THREE.LoopOnce
    actions.action51.timeScale = 1.5
    actions.action51.clampWhenFinished = true
    actions.action51.loop = THREE.LoopOnce
    actions.action15.timeScale = 1.5
    actions.action15.clampWhenFinished = true
    actions.action15.loop = THREE.LoopOnce
  }, [])
  useEffect(() => {
    // console.log(type, slide)
    actions.action12.stop()
    actions.action23.stop()
    actions.action34.stop()
    actions.action45.stop()
    actions.action21.stop()
    actions.action32.stop()
    actions.action43.stop()
    actions.action54.stop()
    actions.action51.stop()
    actions.action15.stop()
    if (type == 'next') {
      switch (slide) {      
        case 2:
          actions.action12.play()
          break
        case 3:
          actions.action23.play()
          break
        case 4:
          actions.action34.play()
          break
        case 5:
          actions.action45.play()
          break
        case 6:
          actions.action51.play()
          break
      }
    } else {
      switch (slide) {
        case 1:
          actions.action21.play()
          break
        case 2:
          actions.action32.play()
          break
        case 3:
          actions.action43.play()
          break
        case 4:
          actions.action54.play()
          break
        case 5:
          actions.action15.play()
          break
      }
    }
  }, [slide])
  let s = Math.min(1,viewport.width / 3)
  return (
    <group ref={group} dispose={null} scale={[s, s, s]}>
      <group position={[0, 0.25, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <primitive object={nodes.Bone1} />
        <primitive object={nodes.Bone2} />
        <primitive object={nodes.Bone3} />
        <primitive object={nodes.Bone4} />
        <primitive object={nodes.Bone5} />
        <primitive object={nodes.Bone6} />
        <primitive object={nodes.Bone7} />
        <primitive object={nodes.Bone8} />
        <skinnedMesh geometry={nodes.Sphere1.geometry} skeleton={nodes.Sphere1.skeleton}>
          <meshMatcapMaterial
            matcap={matcap}
            skinning={true}
            roughness={0}
            metalness={1}
            // clearcoat={1}
            // clearcoatRoughness={1}
          />
          {/* <meshStandardMaterial map={matcap} metalness={0.9} roughness={0} skinning={true}/> */}
        </skinnedMesh>
        <skinnedMesh material={nodes.Sphere2.material} geometry={nodes.Sphere2.geometry} skeleton={nodes.Sphere2.skeleton}>
          <meshMatcapMaterial matcap={matcap} skinning={true} />
        </skinnedMesh>
        <skinnedMesh material={nodes.Sphere3.material} geometry={nodes.Sphere3.geometry} skeleton={nodes.Sphere3.skeleton}>
          <meshMatcapMaterial matcap={matcap} skinning={true} />
        </skinnedMesh>
        <skinnedMesh material={nodes.Sphere4.material} geometry={nodes.Sphere4.geometry} skeleton={nodes.Sphere4.skeleton}>
          <meshMatcapMaterial matcap={matcap} skinning={true} />
        </skinnedMesh>
        <skinnedMesh material={nodes.Sphere5.material} geometry={nodes.Sphere5.geometry} skeleton={nodes.Sphere5.skeleton}>
          <meshMatcapMaterial matcap={matcap} skinning={true} />
        </skinnedMesh>
        <skinnedMesh material={nodes.Sphere6.material} geometry={nodes.Sphere6.geometry} skeleton={nodes.Sphere6.skeleton}>
          <meshMatcapMaterial matcap={matcap} skinning={true} />
        </skinnedMesh>
        <skinnedMesh material={nodes.Sphere7.material} geometry={nodes.Sphere7.geometry} skeleton={nodes.Sphere7.skeleton}>
          <meshMatcapMaterial matcap={matcap} skinning={true} />
        </skinnedMesh>
        <skinnedMesh material={nodes.Sphere8.material} geometry={nodes.Sphere8.geometry} skeleton={nodes.Sphere8.skeleton}>
          <meshMatcapMaterial matcap={matcap} skinning={true} />
        </skinnedMesh>
      </group>
    </group>
  )
}

useGLTF.preload(process.env.PUBLIC_URL +'/Model.glb')
